import { jsxs as S, jsx as i } from "react/jsx-runtime";
import { withManagedProps as g } from "@made-people/managed-props";
import { z as r } from "zod";
import { withZod as k } from "@made-people/react-prop-guard";
import { linkShortcutsBlueprint as f } from "./index-blueprint.es.js";
import { headingSchema as b, Heading as v } from "@made-people/blueprint-heading";
import { ScrollWrapper as y } from "@made-people/blueprint-scroll-wrapper";
import W from "clsx";
import { buttonAsLinkSchema as l, ButtonAsLink as j } from "@made-people/blueprint-button";
import { componentWrapperSchema as x, ComponentWrapper as N } from "@made-people/blueprint-component-wrapper";
import "@made-people/blueprint";
const L = r.object({
  layout: x.shape.layout.optional(),
  variants: r.custom().optional(),
  content: r.object({
    heading: b.optional(),
    links: l.array()
  }).optional(),
  features: r.object({
    linkVariants: l.shape.variants.optional()
  }).optional(),
  className: r.string().optional(),
  /**
   * @deprecated Please avoid use blueprint variant instead.
   */
  useScrollWrapper: r.boolean().optional()
}), q = g(
  "LinkShortcuts",
  k(
    {
      schema: L,
      defaultProps: {
        features: {
          linkVariants: { color: "primary", style: "outline", size: "sm" }
        },
        useScrollWrapper: !0
      }
    },
    ({ variants: e, className: p, content: a, features: s, layout: m, useScrollWrapper: c }) => {
      var t;
      const o = f.styles(e), h = ((t = a == null ? void 0 : a.heading) == null ? void 0 : t.variants) ?? {
        headingSize: "2xs"
      };
      if (!a)
        return null;
      const d = c ? y : "div";
      return /* @__PURE__ */ S(
        N,
        {
          layout: { ...m },
          className: W(o.base, p),
          children: [
            a.heading && /* @__PURE__ */ i(
              v,
              {
                className: o.heading,
                ...a.heading,
                variants: h
              }
            ),
            /* @__PURE__ */ i(d, { className: o.linksWrapper, children: a.links.map((n, u) => /* @__PURE__ */ i("div", { className: o.link, children: /* @__PURE__ */ i(j, { variants: s == null ? void 0 : s.linkVariants, ...n }) }, `${n.label}-${u}`)) })
          ]
        }
      );
    }
  )
);
export {
  q as LinkShortcuts,
  L as linkShortcutsSchema
};
//# sourceMappingURL=index.es.js.map
